module.exports = __webpack_public_path__ + "static/media/logo.d339d637.svg";